<style scoped>
    ::v-deep .v-snack__content {
        /* 外部から設定可能にするために継承する（実際に生成されるタグに反映されるようにする） */
        font-size: inherit;
    }
</style>

<template>
    <!-- v-model="$emit('input', false)" はコンパイルエラーになる -->
    <!-- white-space:pre-wrap; word-wrap:break-word; は改行コード対応 表示文字列に「\n」が含まれている場合改行 -->
    <v-snackbar
        v-model="open"
        top
        app
        :color="dispColor"
        :timeout="timeout"
        :width="width"
        :style="{ fontSize: fontSize + 'px' }"
        style="white-space:pre-wrap; word-wrap:break-word;"
    >
        <slot>完了しました</slot>
        <template v-slot:action="{ attrs }">
            <v-btn
                color="white"
                text
                @click="$emit('input', false)"
            >
            <v-icon>mdi-close-circle</v-icon>
            </v-btn>
        </template>
    </v-snackbar>
</template>
<script>
    export default {
        data() {
            return {
                dispColor: "green"
            };
        },
        computed: {
            open: {
                get() {
                    // 成功か失敗かで色を変更する
                    this.dispColor = this.success ? this.color : this.errorColor;
                    return this.value;
                },
                set(value) {
                    // 親コンポーネントへの通知
                    this.$emit('input', value);
                }
            },
        },
        props: {
            value: {
                type: Boolean,
                default: false,
            },
            success: {
                default: false,
            },
            fontSize: {
                type: String,
                default: "20",
            },
            color: {
                type: String,
                default: "green"
            },
            errorColor: {
                type: String,
                default: "red"
            },
            timeout: {
                type: String,
                default: "5000"
            },
            width: {
                type: String,
                default: "100%"
            },
        },
    }
</script>